<template lang="pug">
.form-group.dawn-radio-group(:class='{ error }')
  label.control-label(v-if='fieldLabel', :class='{ error }') {{ fieldLabel }}
    span(v-if='required') &nbsp;*
  ed-input-tooltip(v-if='helptipBody && error'
                  :class='{ "error-message": error }'
                  :helptipHeader='helptipHeader'
                  :errorTip='error'
                  :helptipBody='helptipBody'
  )
  radio(v-for='(option, i) in options'
        v-model='value'
        v-show='!option.hide'
        :name='name'
        :key='i'
        :option-index='i'
        :option-label='option.label'
        :option-value='option'
        :checked='checked(option)'
        :track-by='$attrs["track-by"]'
        @choose-radio='set(option)'
        :hasAdditionalInfo='option.additionalInfo'
        :slotName='option.slotName'
        :error='error'
  )
    slot(:value='option.value' slot='icon' name='icon')
    slot(:value='option.value' :slot='option.slotName' :name='option.slotName' :slotName='option.slotName')
</template>

<script>

import Radio from './radio.vue'

export default {
  name: 'ed-radio',

  props: {
    fieldLabel: String,
    value: null,
    name: String,
    options: Array,
    disabled: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    error: Boolean,
    helptipHeader: String,
    helptipBody: String
  },

  components: {
    'radio': Radio
  },

  created() {
    this.hasKey = this.value && this.value.constructor === Array && this.$attrs['track-by']
  },

  methods: {
    set(v) {
      this.$emit('select')
      this.$emit('input', this.hasKey ? [v[this.hasKey]] : v)
      this.$emit('click')
    },
    checked(option) {
      if (this.hasKey) {
        return this.value.indexOf(option[this.hasKey]) >= 0
      }
    }
  }
}

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.form-group.option.inline {
  display: inline;
  margin: 0;
}
.form-group.dawn-radio-group {
  &.error {
    position: relative;
  }
  & {
    .dawn-input-tooltip.error-message {
      //position: relative;
      min-width: 350px;
      top: -1.1em;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edRadio/index.vue